import { useEffect } from "react";
import { SITE } from "@/lib/content";

export function JsonLd({ data, id }: { data: object; id: string }) {
  return <script type="application/ld+json" data-schema={id} dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}

export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = `${title} | ${SITE.name}`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
  }, [title, description]);
}

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "HealthAndBeautyBusiness",
  name: SITE.name,
  url: SITE.url,
  logo: `${SITE.url}/logo.png`,
  image: `${SITE.url}/images/hero.jpg`,
  telephone: SITE.phoneTel,
  email: SITE.email,
  priceRange: "₹₹",
  founder: { "@type": "Person", name: SITE.founder },
  slogan: "Nourish · Energise · Transform",
  address: {
    "@type": "PostalAddress",
    streetAddress: `${SITE.street}, ${SITE.locality}`,
    addressLocality: SITE.cityName,
    addressRegion: SITE.region,
    postalCode: SITE.postalCode,
    addressCountry: "IN",
  },
  areaServed: ["Kazhakootam", "Technopark", "Kariavattom", "Sreekariyam", "Thiruvananthapuram", "Kerala", "Online"],
  openingHours: ["Mo-Su 06:30-11:00", "Mo-Su 17:00-20:30"],
});

export const personSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Person",
  name: SITE.founder,
  jobTitle: "Wellness Coach",
  description: `Wellness coach, not dietitian. Lost ${SITE.founderKg} kg on his own journey.`,
  worksFor: { "@type": "Organization", name: SITE.name },
  telephone: SITE.phoneTel,
  email: SITE.email,
});

export const serviceSchema = (name: string, description: string, path: string, price?: string) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  url: `${SITE.url}${path}`,
  serviceType: "Wellness and nutrition coaching",
  provider: { "@type": "HealthAndBeautyBusiness", name: SITE.name, telephone: SITE.phoneTel },
  ...(price ? { offers: { "@type": "Offer", price, priceCurrency: "INR", description: "Per month, 120-day programme" } } : {}),
});

export const faqSchema = (items: { question: string; answer: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })),
});
